export default __webpack_public_path__ + "static/media/h2.a9986570.png";